import api from './index'

export function getMediaHubMainBanners(params) {
  return api.get('/api/v1/media-hub/main-banners', { params })
}

export function getMediaHubStatistics() {
  return api.get('/api/v1/media-hub/statistics')
}

export function createMediaHubMainBanner(data) {
  return api.post('/api/v1/media-hub/main-banners', data)
}

export function updateMediaHubMainBanner(mainBannerCode, data) {
  return api.put(`/api/v1/media-hub/main-banners/${mainBannerCode}`, data)
}

export function deleteMediaHubMainBanner(mainBannerCode) {
  return api.delete(`/api/v1/media-hub/main-banners/${mainBannerCode}`)
}

export function getMediaHubCategories(params) {
  return api.get('/api/v1/media-hub/categories', { params })
}

export function createMediaHubCategory(data) {
  return api.post('/api/v1/media-hub/categories', data)
}

export function updateMediaHubCategory(categoryCode, data) {
  return api.put(`/api/v1/media-hub/categories/${categoryCode}`, data)
}

export function toggleMediaHubCategoryActive(categoryCode) {
  return api.post(`/api/v1/media-hub/categories/${categoryCode}/active`)
}

export function getMediaHubDisplayCategories(params) {
  return api.get('/api/v1/media-hub/display-categories', { params })
}

export function createMediaHubDisplayCategory(data) {
  return api.post('/api/v1/media-hub/display-categories', data)
}

export function updateMediaHubDisplayCategory(displayCategoryCode, data) {
  return api.put(`/api/v1/media-hub/display-categories/${displayCategoryCode}`, data)
}

export function toggleMediaHubDisplayCategoryActive(displayCategoryCode) {
  return api.post(`/api/v1/media-hub/display-categories/${displayCategoryCode}/active`)
}

export function getMediaSources(params) {
  return api.get('/api/v1/media-hub/sources', { params })
}

export function createMediaSource(data) {
  return api.post('/api/v1/media-hub/sources', data)
}

export function updateMediaSource(mediaSourceCode, data) {
  return api.put(`/api/v1/media-hub/sources/${mediaSourceCode}`, data)
}

export function toggleMediaSourceActive(mediaSourceCode) {
  return api.post(`/api/v1/media-hub/sources/${mediaSourceCode}/active`)
}

export function deleteMediaSource(mediaSourceCode) {
  return api.delete(`/api/v1/media-hub/sources/${mediaSourceCode}`)
}

export function getMediaHubContents(params) {
  return api.get('/api/v1/media-hub/contents', { params })
}

export function createManualMediaHubContent(data) {
  return api.post('/api/v1/media-hub/contents/manual', data)
}

export function previewMediaHubContentUrl(data) {
  return api.post('/api/v1/media-hub/contents/preview-url', data)
}

export function getHomepageExposures(params) {
  return api.get('/api/v1/media-hub/homepage-exposures', { params })
}

export function runMediaHubFetch() {
  return api.post('/api/v1/media-hub/fetch/run')
}

export function runMediaSourceFetch(mediaSourceCode) {
  return api.post(`/api/v1/media-hub/sources/${mediaSourceCode}/fetch`)
}

export function exposeMediaHubContent(fetchCode, data) {
  return api.post(`/api/v1/media-hub/contents/${fetchCode}/expose`, data)
}

export function unexposeMediaHubContent(homepageContentCode) {
  return api.post(`/api/v1/media-hub/homepage-exposures/${homepageContentCode}/unexpose`)
}
